import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import { StatusCodes } from 'http-status-codes';
import { Typography } from '@mui/material';
import DomainStatusIcons from '../DomainStatusIcons';
import { isCertificateValid } from '../../../../utils/domainTools';
import BlogStatusMessage from '../BlogStatusMessage';
import { blogShape, domainShape } from '../../../../domain/PropTypes';
import { dateToReadableTime } from '../../../../utils/dateTime';
import { fonts } from '../../../../theme';
import DomainName from '../DomainName';

const SubdomainStatus = ({ subdomain, blog }) => {
  const { domainName, domainStatus } = subdomain;
  const { statusCode, isShowit, checkDate } = domainStatus;

  return (
    <Card
      elevation={0}
      sx={{
        p: 2.5,
        mb: 1,
        boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
      }}
    >
      <DomainName domainName={domainName} />
      <DomainStatusIcons
        statusCode={statusCode}
        statusOk={statusCode === StatusCodes.OK}
        sslEnabled={isCertificateValid(domainStatus)}
        isShowit={isShowit}
      />
      <BlogStatusMessage hasBlogPlan={!!blog} blog={blog} />
      <>
        {checkDate && (
          <>
            <Typography fontSize="0.75rem" fontFamily={fonts.ambit}>
              site status last checked {dateToReadableTime(checkDate)}
            </Typography>
          </>
        )}
      </>
    </Card>
  );
};
SubdomainStatus.propTypes = {
  subdomain: PropTypes.shape(domainShape).isRequired,
  blog: blogShape,
};
SubdomainStatus.defaultProps = {
  blog: undefined,
};
export default SubdomainStatus;
